module.exports = __webpack_public_path__ + "static/media/05_tn.9e9c6bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/05_tn.jpg
// module id = 494
// module chunks = 0